export const reorderArr = <T>(
  list: T[],
  startIndex: number,
  endIndex: number = 0,
) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
